import { useSelector } from "react-redux"

export const useUpdateRequestData = (type) =>{
    const {updateState,updateType,data} = useSelector((state)=>state.updateData)
    if(updateState && updateType === type){
        return data;
    }else
        return null;
}